import { createContext } from 'react';
import { FileConversionConfiguration } from 'vopay';

export type FileConfigurationCtx = {
  configurations: FileConversionConfiguration[];
  configurationsLoading: boolean;
};

export const FileConfigurationContext = createContext<FileConfigurationCtx>({
  configurations: [],
  configurationsLoading: false,
});
